/**
 *  @class
 *  @function ProductRecommendations
 */
class ProductRecommendations extends HTMLElement {
	constructor() {
		super();

		this.parent = this.closest('.product-recommendations--parent');

	}
	fetchProducts() {
		fetch(this.dataset.url)
			.then(response => response.text())
			.then(text => {
				const html = document.createElement('div');
				html.innerHTML = text;
				const recommendations = html.querySelector('product-recommendations');

				if (recommendations && recommendations.innerHTML.trim().length) {
					this.innerHTML = recommendations.innerHTML;

					if ( this.parent ) {
						this.parent.classList.add('product-recommendations--full');

						if ( document.body.classList.contains('open-cart')) {
							this.parent.classList.add('active');
						}
					}
                    this.initializeVariantSwatches();
				}

				this.classList.add('product-recommendations--loaded');

			})
			.catch(e => {
				console.error(e);
			});
	}
	connectedCallback() {
		this.fetchProducts();
	}
    initializeVariantSwatches() {
        const swatches = this.querySelectorAll('.product-card-swatch');

        swatches.forEach(swatch => {
            swatch.addEventListener('click', function () {
                const selectedVariantId = this.getAttribute('data-variant-id');
                const productCard = this.closest('.product-card');
                const images = productCard.querySelectorAll('.product-secondary-image');

                images.forEach(image => {
                    image.style.display = 'none';
                });
              
                images.forEach(image => {
                    const variantIds = image.getAttribute('data-variant-ids').split(',');
                    if (variantIds.includes(selectedVariantId)) {
                        image.style.display = 'block';
                    }
                });
            });
        });
    }
}
customElements.define('product-recommendations', ProductRecommendations);